"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.message = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reduxAct = require("redux-act");

var _constants = require("../../../../constants");

var _message = require("./message.helpers");

var actions = _interopRequireWildcard(require("./message.actions"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var initialState = {
  isLoading: false,
  isSaved: false,
  isDraft: true,
  templateName: '',
  templateId: null,
  errors: {
    subject: null,
    text: null
  },
  subject: '',
  shadowSubject: '',
  text: '',
  shadowText: '',
  previewUrl: '',
  defaultSubject: '',
  state: _constants.stepState.DISABLED
};
exports.initialState = initialState;
var message = (0, _reduxAct.createReducer)({}, initialState).on(actions.setMessageDraft, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isDraft: true,
    state: _constants.stepState.ACTIVE
  });
}).on(actions.setTemplateMessage, function (state, payload) {
  var _payload$text = payload.text,
      text = _payload$text === void 0 ? state.text : _payload$text,
      _payload$shadowText = payload.shadowText,
      shadowText = _payload$shadowText === void 0 ? state.shadowText : _payload$shadowText,
      _payload$subject = payload.subject,
      subject = _payload$subject === void 0 ? state.subject : _payload$subject,
      _payload$shadowSubjec = payload.shadowSubject,
      shadowSubject = _payload$shadowSubjec === void 0 ? state.shadowSubject : _payload$shadowSubjec,
      _payload$templateName = payload.templateName,
      templateName = _payload$templateName === void 0 ? state.templateName : _payload$templateName,
      _payload$templateId = payload.templateId,
      templateId = _payload$templateId === void 0 ? state.templateId : _payload$templateId,
      _payload$isDraft = payload.isDraft,
      isDraft = _payload$isDraft === void 0 ? state.isDraft : _payload$isDraft,
      _payload$previewUrl = payload.previewUrl,
      previewUrl = _payload$previewUrl === void 0 ? state.previewUrl : _payload$previewUrl,
      _payload$defaultSubje = payload.defaultSubject,
      defaultSubject = _payload$defaultSubje === void 0 ? state.defaultSubject : _payload$defaultSubje;
  return _objectSpread(_objectSpread({}, state), {}, {
    isSaved: true,
    isDraft,
    text,
    shadowText,
    subject,
    shadowSubject,
    templateName,
    templateId,
    previewUrl,
    defaultSubject,
    state: state.isDraft ? _constants.stepState.ACTIVE : _constants.stepState.PASSED,
    errors: {
      subject: null,
      text: null
    }
  });
}).on(actions.setSubject, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isSaved: false,
    subject: payload
  });
}).on(actions.setShadowSubject, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isSaved: false,
    shadowSubject: payload
  });
}).on(actions.setSubjectError, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    errors: _objectSpread(_objectSpread({}, state.errors), {}, {
      subject: payload
    })
  });
}).on(actions.setText, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isSaved: false,
    text: payload
  });
}).on(actions.setShadowText, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isSaved: false,
    shadowText: payload
  });
}).on(actions.setTextError, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    errors: _objectSpread(_objectSpread({}, state.errors), {}, {
      text: payload
    })
  });
}).on(actions.updateMessage, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: true,
    isDraft: payload.isDraft
  });
}).on(actions.updateMessageSuccess, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false,
    isSaved: true,
    state: state.isDraft ? _constants.stepState.ACTIVE : _constants.stepState.PASSED
  });
}).on(actions.updateMessageFail, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    errors: (0, _message.convertMessageError)(payload),
    isLoading: false,
    isSaved: false,
    isDraft: true
  });
}).on(actions.resetSalesIntegrationsMessage, function () {
  return _objectSpread({}, initialState);
});
exports.message = message;